import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createStatementsSyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.STATEMENTS_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            statements: [
                {
                    date: '2020-06-15T12:00:00.000Z',
                    payPeriodStartDate: '2020-05-27T12:00:00.000Z',
                    payPeriodEndDate: '2020-06-12T12:00:00.000Z',
                    grossAmount: 1000,
                    ytdGrossAmount: 10000,
                    netAmount: 800,
                    ytdNetAmount: 8000,
                    deductions: [
                        {
                            category: 'taxes',
                            label: 'Federal Income Tax',
                            rawLabel: 'Federal Income Tax',
                            amount: 200,
                            ytdAmount: 2000
                        },
                        {
                            category: 'taxes',
                            label: 'State Income Tax',
                            rawLabel: 'Utah State Tax',
                            amount: 50,
                            ytdAmount: 500
                        },
                        {
                            category: 'other',
                            label: 'Abc corp dd',
                            rawLabel: 'Abc corp dd',
                            amount: 5,
                            ytdAmount: 50
                        }
                    ],
                    earnings: [
                        {
                            category: 'benefit',
                            rawLabel: 'Social Security (Disability)',
                            amount: 1000
                        },
                        {
                            category: 'bonus',
                            rawLabel: 'Quarterly Bonus',
                            amount: 2000,
                            ytdAmount: 6000
                        },
                        {
                            category: 'overtime',
                            rawLabel: 'Overtime Pay',
                            amount: 100,
                            ytdAmount: 1000,
                            hours: 10,
                            rate: 15
                        },
                        {
                            category: 'reimbursement',
                            rawLabel: 'Gas Card',
                            amount: 25.47,
                            ytdAmount: 85.74
                        }
                    ],
                    paystub: {
                        _id: '60abeff50836730008616fad',
                        url: '[ATOMIC-GENERATED-PRESIGNED-S3-URL]'
                    }
                },
                {
                    date: '2020-06-30T12:00:00.000Z',
                    payPeriodStartDate: '2020-05-27T12:00:00.000Z',
                    payPeriodEndDate: '2020-06-12T12:00:00.000Z',
                    grossAmount: 1000,
                    deductions: [
                        {
                            category: 'taxes',
                            label: 'Federal Income Tax',
                            rawLabel: 'Federal Income Tax',
                            amount: 200
                        },
                        {
                            category: 'taxes',
                            label: 'State Income Tax',
                            rawLabel: 'Utah State Tax',
                            amount: 50
                        },
                        {
                            category: 'other',
                            label: 'Abc corp dd',
                            rawLabel: 'Abc corp dd',
                            amount: 5
                        }
                    ],
                    paystub: {
                        _id: '60abeff50836730008616fae',
                        url: '[ATOMIC-GENERATED-PRESIGNED-S3-URL]'
                    }
                }
            ],
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=statements-synced.js.map